export default {
  "accountingReportDownload.th.theaterName": "劇場名",
  "accountingReportDownload.th.month": "対象月",
  "accountingReportDownload.th.accountName": "実施アカウント名",
  "accountingReportDownload.th.createDateTime": "作成日時",

  /** create record dialog */
  "accountingReportDownload.dialog.title": "会計仕訳/伝票　登録/編集",
  "accountingReportDownload.dialog.theaterName": "劇場名",
  "accountingReportDownload.dialog.month": "対象月",
  "accountingReportDownload.dialog.personNumber": "担当者番号（会計仕訳/システム連携）",
  "accountingReportDownload.dialog.personNumber.placeholder": "担当者番号を入力してください",
  "accountingReportDownload.dialog.placeholder": "選択してください",
  "accountingReportDownload.dialog.reportName": "伝票名",

  "accountingReportDownload.dialog.dailyReport": "日報計上",
  "accountingReportDownload.dialog.filmFeeReport": "フィルム料計上",
  "accountingReportDownload.dialog.accountsPayable": "買掛未払計上",
  "accountingReportDownload.dialog.filmFeePayment": "フィルム料支払",

};